export default "__VITE_ASSET__CjdOhs9J__"